var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [
      _vm._v("Препарат: "),
      _c("strong", [_vm._v(_vm._s(_vm.task.task_data?.drug?.title))]),
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.task.task_data?.drug?.group))]),
    _vm._v(" "),
    _vm.task.task_data?.comment
      ? _c("p", [_vm._v(_vm._s(_vm.task.task_data.comment))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row mt-2" },
      _vm._l(_vm.codes, function (code, alias) {
        return _c(
          "div",
          { staticClass: "col-md-4" },
          [
            _c("div", { staticClass: "flex justify-content-between" }, [
              _c("span", [_vm._v(_vm._s(code.title))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ml-1 btn btn-xs btn-default",
                  on: {
                    click: function ($event) {
                      return _vm.addCode(alias)
                    },
                  },
                },
                [_vm._v("добавить")]
              ),
            ]),
            _vm._v(" "),
            _vm._l(code.codes, function (d, i) {
              return _c("div", { staticClass: "flex mt-1" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: d.text,
                      expression: "d.text",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: d.text },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(d, "text", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.removeCode(alias, i)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                ),
              ])
            }),
          ],
          2
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-2" },
      [
        _c("CommentsBlock", {
          attrs: { task: _vm.task, updateTasks: _vm.updateTasks },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-2 text-right mb-1" }, [
      _c(
        "div",
        { staticClass: "flex flex_gap_10 justify-content-end" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Создать задачу",
              loading: _vm.loading,
              color: "white",
              onClick: () => _vm.saveTask(),
              className: "btn btn-outline-success",
            },
          }),
          _vm._v(" "),
          _c("LoadingButton", {
            attrs: {
              title: "Сохранить изменения",
              loading: _vm.loading,
              color: "white",
              onClick: () => _vm.saveTask(),
              className: "btn btn-success",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }